<template>
  <div id="app">
    <el-container>
      <el-header class="div-header">
        <Header />
        <el-divider class="header-divider"></el-divider>
      </el-header>
      <div class="main-div">
        <el-container class="main-div parentDiv">
          <splitpanes class="default-theme defaultStyle custom-splite">
            <pane size="100" class="SideBarLeft">
              <!--SID0012 Body Part start-->
              <template>
                <div class="SID1022_UserConditionRegister">
                  <!-- Body top section -->
                  <section>
                    <el-breadcrumb separator-class="el-icon-arrow-right" class="SearchRegisterLink">
                      <el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧) </el-breadcrumb-item>
                      <el-breadcrumb-item :to="{ path: '1021' }">記事件数確認条件設定</el-breadcrumb-item>
                      <el-breadcrumb-item :to="{ path: '' }">記事件数確認</el-breadcrumb-item>
                    </el-breadcrumb>
                    <div class="SID1022_UserConditionRegister1022">
                      <!-- 
                      * Backlog issue related fix
                      * Author: BM
                      * Backlog Id: BT08460_EXTERNAL-1747 
                      * To display only the media with a contract on the article count confirmation screen.
                      * Added div for hide the non contract media
                      -->
                      <div v-if="mc_datasection==1">
                      <div class="user-register1022">
                        <span>EL記事</span>
                      </div>
                      <el-table border :data="getTableResult1022MC" style="width:100%" >
                        <el-table-column prop="process_date" label="" min-width="100"></el-table-column>
                        <el-table-column  prop="theme_count" label="テーマ件数合計（延べ数）" min-width="190"></el-table-column>
                        <el-table-column prop="article_count" label="記事件数合計（記事重複なし）" min-width="220"> </el-table-column>
                        <!--For dynamic columns as themes exist MC-->
                        <el-table-column :label="theme" :prop="JSON.stringify({theme, property:'theme_article_count'})" align="center" min-width="140"
                              v-for="(theme, index) in theme_info_mc" :key="index" :formatter="cellFormatter">
                        </el-table-column>
                      </el-table>
                      </div>
                      <!-- 
                      * Backlog issue related fix
                      * Author: BM
                      * Backlog Id: BT08460_EXTERNAL-1747 
                      * To display only the media with a contract on the article count confirmation screen.
                      * Added div for hide the non contract media
                      -->
                      <div v-if="sc_datasection==1">
                      <div class="user-register1022">
                        <span>日経記事</span>
                      </div>
                      <el-table :data="getTableResult1022SC" border style="width: 100%" >
                        <el-table-column prop="process_date" label="" min-width="100"> </el-table-column>
                        <el-table-column  prop="theme_count" label="テーマ件数合計（延べ数）" min-width="190"></el-table-column>
                        <el-table-column prop="article_count" label="記事件数合計（記事重複なし）" min-width="220"> </el-table-column>
                        <!--For dynamic columns as themes exist SC-->
                        <el-table-column :label="theme" :prop="JSON.stringify({theme, property:'theme_article_count'})" align="center" min-width="140"
                              v-for="(theme, index) in theme_info_sc" :key="index" :formatter="cellFormatter">
                        </el-table-column>
                      </el-table>
                      </div>
                      
                      <div v-if="magazine_datasection==1">
                      <div class="user-register1022">
                        <span>雑誌</span>
                      </div>
                      <el-table :data="getTableResult1022Magazine" border style="width: 100%" >
                        <el-table-column prop="process_date" label="" min-width="100"> </el-table-column>
                        <el-table-column  prop="theme_count" label="テーマ件数合計（延べ数）" min-width="190"></el-table-column>
                        <el-table-column prop="article_count" label="記事件数合計（記事重複なし）" min-width="220"> </el-table-column>
                        <!--For dynamic columns as themes exist Magazine-->
                        <el-table-column :label="theme" :prop="JSON.stringify({theme, property:'theme_article_count'})" align="center" min-width="140"
                              v-for="(theme, index) in theme_info_magazine" :key="index" :formatter="cellFormatter">
                        </el-table-column>
                      </el-table>
                      </div> 
                      <!-- 
                      * Backlog issue related fix
                      * Author: BM
                      * Backlog Id: BT08460_EXTERNAL-1747 
                      * To display only the media with a contract on the article count confirmation screen.
                      * Added div for hide the non contract media
                      -->
                      <div v-if="web_datasection==1">
                      <div class="user-register1022">
                        <span>WEBニュース</span>
                      </div>
                      <el-table :data="getTableResult1022WEB" border style="width: 100%" >
                        <el-table-column prop="process_date" label="" min-width="100"> </el-table-column>
                        <el-table-column  prop="theme_count" label="テーマ件数合計（延べ数）" min-width="190"></el-table-column>
                        <el-table-column prop="article_count" label="記事件数合計（記事重複なし）" min-width="220"> </el-table-column>
                        <!--For dynamic columns as themes exist WEB-->
                        <el-table-column :label="theme" :prop="JSON.stringify({theme, property:'theme_article_count'})" align="center" min-width="140"
                              v-for="(theme, index) in theme_info_web" :key="index" :formatter="cellFormatter">
                        </el-table-column>
                      </el-table>
                      </div>
                    </div> 
                  </section>
                </div>
              </template>  
              <!--SID0012 Body Part end-->
            </pane>
            <pane class="SideBarRight">
              <SideBar class="SidePane" />
            </pane>
          </splitpanes>
        </el-container>
      </div>
      <el-container class="footer-div">
        <el-footer class="footer-element">
          <FooterComponent />
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
export default {
  name: "UserConditionRegister",
  components: {
    Header,
    SideBar,
    FooterComponent,
    Splitpanes,
    Pane
  },
  
  methods: {
    cellFormatter(row, col) {
      let key = JSON.parse(col.property)
      let d = row.theme_info.find(r => r.theme_name === key.theme)
      if (d && d[key.property]) {
        return d[key.property]
      }
      return '0 '
    }
  },
  computed: {
    theme_info_mc() {
      let theme_info = {}
      this.getTableResult1022MC.forEach(row => {
        row.theme_info.forEach(room => {
          theme_info[room.theme_name] = 1
        })
      })
      return Object.keys(theme_info)
    },
    theme_info_sc() {
      let theme_info = {}
      this.getTableResult1022SC.forEach(row => {
        row.theme_info.forEach(room => {
          theme_info[room.theme_name] = 1
        })
      })
      return Object.keys(theme_info)
    },
     theme_info_magazine() {
      let theme_info = {}
      this.getTableResult1022Magazine.forEach(row => {
        row.theme_info.forEach(room => {
          theme_info[room.theme_name] = 1
        })
      })
      return Object.keys(theme_info)
    },
    theme_info_web() {
      let theme_info = {}
      this.getTableResult1022WEB.forEach(row => {
        row.theme_info.forEach(room => {
          theme_info[room.theme_name] = 1
        })
      })
      return Object.keys(theme_info)
    },
    ...mapGetters("situation1022", [
                    "getTableResult1022MC",
                    "getTableResult1022SC",
                    "getTableResult1022Magazine",
                    "getTableResult1022WEB"]),
                    /*
                    * Backlog issue related fix
                    * Author: BM
                    * Backlog Id: BT08460_EXTERNAL-1747 
                    * To display only the media with a contract on the article count confirmation screen.
                    * Added mapgetters situation0001
                    */
                    ...mapGetters("situation0001", [
                        "getServiceLinkageInfo"
                      ])
  },
  beforeCreate(){
    //For the screen Title
    document.title = "記事件数確認条件設定画面";
  },
  mounted(){
    this.$store.dispatch('communication1022/getTableDetails',this.$route.query);
    /*
    * Backlog issue related fix
    * Author: BM
    * Backlog Id: BT08460_EXTERNAL-1747 
    * To display only the media with a contract on the article count confirmation screen.
    * Get the servicelinkage info from situation0001 instead from the session  
    */
    var servicelinkageTo_know_sc_exist=this.getServiceLinkageInfo;
    for (var l = 0; l < servicelinkageTo_know_sc_exist.length; l++) {
      if (servicelinkageTo_know_sc_exist[l].data_section == 1){
        this.mc_datasection = 1;
      }
      if (servicelinkageTo_know_sc_exist[l].data_section == 2){
        this.sc_datasection = 1;
      }
      if (servicelinkageTo_know_sc_exist[l].data_section == 3){
        this.web_datasection = 1;
      }
      if (servicelinkageTo_know_sc_exist[l].data_section == 5){
        this.magazine_datasection = 1;
      }
    } 
  },
  data() {
    return {
      MCdate:[],
      SCdate:[],
      /*
      * Backlog issue related fix
      * Author: BM
      * Backlog Id: BT08460_EXTERNAL-1747 
      * To display only the media with a contract on the article count confirmation screen.
      */
      mc_datasection: 0,
      sc_datasection: 0,
      magazine_datasection: 0,
      web_datasection: 0
    }
  }
}
</script>

<style scoped>
@import "1022.css";
</style>